import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ButtonModule } from 'primeng/button';
import { ModalService } from '../../services/modal.service';
import { TranslateModule } from '@ngx-translate/core';
import { GoogleCalendarPickerModalComponent } from './google-calendar-picker-modal/google-calendar-picker-modal.component';
import { GoogleCalendarIconComponent } from './google-calendar-icon/google-calendar-icon.component';
import { take } from 'rxjs';
import { ApisService, ICalendarFE } from '../../services/entities/apis/apis.service';
import { SelectedOrgService } from '../../services/selected-org.service';

@Component({
  selector: 'app-google-calendar-sync',
  standalone: true,
  imports: [
    CommonModule, ButtonModule, NgbTooltipModule, TranslateModule, GoogleCalendarIconComponent
  ],
  templateUrl: './google-calendar-sync.component.html',
  styleUrl: './google-calendar-sync.component.scss'
})
export class GoogleCalendarSyncComponent implements OnInit {

  @Input() disabled = false;
  @Input() disabledTooltip = '';
  @Input() locationId?: number;
  @Input() lecturerUserId?: number;

  fetchingCalendars = false;
  deletingCalendarMap: { [id: number]: boolean | undefined; } = {};
  calendars: ICalendarFE[] = [];

  constructor(
    private modalService: ModalService,
    private selectedOrgService: SelectedOrgService,
    private apiService: ApisService
  ) {}

  ngOnInit(): void {
    if (!this.disabled) this.getCalendars();
  }

  private getCalendars() {
    const orgId = this.selectedOrgService.getCurrentValue();
    if (!orgId) {
      console.error('Missing orgId!');
      return;
    }
    if (!this.lecturerUserId && !this.locationId) {
      console.error('Missing lecturerUserId or locationId');
      return;
    }

    this.fetchingCalendars = true;
    this.apiService.getConnectedCalendars({
      orgId,
      lecturerUserId: this.lecturerUserId,
      locationId: this.locationId
    }).pipe(take(1)).subscribe({
      next: (calendars) => {
        this.calendars = calendars;
        this.fetchingCalendars = false;
      },
      error: () => {
        this.fetchingCalendars = false;
      }
    });
  }

  onConnect() {
    this.modalService.openGoogleCalendarPickerModal(GoogleCalendarPickerModalComponent, this.locationId, this.lecturerUserId).pipe(take(1)).subscribe((res) => {
      this.getCalendars();
    });
  }

  onRemove(calendar: ICalendarFE) {
    const orgId = this.selectedOrgService.getCurrentValue();
    if (!orgId || !calendar.id) {
      console.error('Missing id!');
      return;
    }

    this.deletingCalendarMap[calendar.id] = true;
    this.apiService.disconnectGoogleCalendar({
      orgId,
      calendarId: calendar.id,
      lecturerUserId: this.lecturerUserId,
      locationId: this.locationId
    }).pipe(take(1)).subscribe({
      next: () => {
        this.calendars = this.calendars.filter((c) => c.id !== calendar.id);
        this.deletingCalendarMap[calendar.id!] = false;
      },
      error: () => {
        this.deletingCalendarMap[calendar.id!] = false;
      }
    });
  }
}
